import * as React from 'react'

import { Button, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import Popover from 'modules/core/components/PopoverMenu'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import i18n from 'modules/core/lib/i18n'

import type { AssessmentGroup } from 'modules/competencies/store/models/AssessmentGroup'

interface DeleteModalProps {
  assessmentGroup: AssessmentGroup
  isDraft: boolean
  onClose: () => void
}

const DeleteModal = observer(({ assessmentGroup, isDraft, onClose }: DeleteModalProps) => {
  const { running, performAction } = useAsyncAction(async () => {
    await assessmentGroup.destroy()
    onClose()
  })

  const description = isDraft
    ? i18n.t('competencies_v2.assessments.actions.delete_modal.not_assessed')
    : i18n.t('competencies_v2.assessments.actions.delete_modal.assessed')

  return (
    <Modal
      illustration="alert"
      title={i18n.t('competencies_v2.assessments.actions.delete_modal.title')}
      description={description}
      onClose={onClose}
      onSubmit={performAction}
      footer={
        <>
          <Button type="secondary" disabled={running} onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={running} submit>
            {i18n.t('common.destroy')}
          </Button>
        </>
      }
    />
  )
})

interface ActionsProps {
  assessmentGroup: AssessmentGroup
  isDraft: boolean
}

const Actions = ({ assessmentGroup, isDraft }: ActionsProps) => {
  const [deleteModalOpen, toggleDeleteModal] = useToggle(false)

  return (
    <>
      <Popover type="list">
        <Popover.Trigger>
          <Button.Decorative type="secondary" iconName="ellipsis" />
        </Popover.Trigger>
        <Popover.Content side="bottom" align="end">
          <Popover.TouchableOption
            onClick={toggleDeleteModal(true)}
            title={i18n.t('competencies_v2.assessments.actions.delete')}
            danger
          />
        </Popover.Content>
      </Popover>
      {deleteModalOpen && (
        <DeleteModal
          assessmentGroup={assessmentGroup}
          onClose={toggleDeleteModal(false)}
          isDraft={isDraft}
        />
      )}
    </>
  )
}

export default observer(Actions)
